import { createClient } from '@/shared/api/client'
import { buildUrl } from '@/shared/utils/urls'
import { TargetSystem } from '@/shared/constants'
import { validateResponseHasSchema, validateResponseIsOk } from '@/shared/api/validation'
import { z } from 'zod'

const client = createClient(buildUrl(TargetSystem.CoreApi))

export const exchangeOAuthCodeForToken = async (code: string) => validateResponseIsOk(
  client.sendPost('authentication/oauth/tokens', {
    data: {
      code
    }
  })
)
